import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import RegistrationPage from './pages/RegistrationPage';

// Personalização do tema do Chakra UI
const theme = extendTheme({
  colors: {
    brand: {
      50: '#e9f5e9',
      100: '#c7e6c7',
      200: '#a3d6a3',
      300: '#7ec77e',
      400: '#5ab85a',
      500: '#4caf4c',
      600: '#429142',
      700: '#387038',
      800: '#2e502e',
      900: '#1e301e',
    },
    // Cores da bandeira italiana
    italy: {
      green: '#009246',
      white: '#ffffff',
      red: '#cf2b36'
    }
  },
  fonts: {
    heading: 'Roboto, sans-serif',
    body: 'Roboto, sans-serif',    
  },
  styles: {
    global: {
      body: {
        bg: 'gray.50',
        color: 'gray.800',
      }
    }
  }
});

function App() {
  return (
    <ChakraProvider theme={theme}>
      <RegistrationPage />
    </ChakraProvider>
  );
}

export default App; 